import { localisedPath } from 'common/url_locale_helper';

export const shopPods = () => localisedPath('/shop/pods');
export const checkout = () => localisedPath('/checkout');
export const autoShip = () => localisedPath('/auto-ship');
